import { PaymentMethod, PaymentMethodType } from "@types-runway/billing";

const isLinkPaymentMethod = (paymentMethod: PaymentMethod) =>
  paymentMethod.type === PaymentMethodType.LINK;

export const collectLinkPaymentMethodIds = (paymentMethods: PaymentMethod[]): string[] =>
  paymentMethods.filter(isLinkPaymentMethod).map((paymentMethod) => paymentMethod.id);

export const dedupeLinkPaymentMethods = (
  paymentMethods: PaymentMethod[],
  defaultPaymentMethodId?: string
): PaymentMethod[] => {
  const representativeLinkMethod =
    paymentMethods.find(
      (paymentMethod) =>
        isLinkPaymentMethod(paymentMethod) && paymentMethod.id === defaultPaymentMethodId
    ) ?? paymentMethods.find(isLinkPaymentMethod);

  let hasShownLinkMethod = false;

  return paymentMethods.reduce<PaymentMethod[]>((displayedMethods, paymentMethod) => {
    if (!isLinkPaymentMethod(paymentMethod)) {
      return [...displayedMethods, paymentMethod];
    }
    if (hasShownLinkMethod) {
      return displayedMethods;
    }
    hasShownLinkMethod = true;
    return [...displayedMethods, representativeLinkMethod as PaymentMethod];
  }, []);
};
